export default __webpack_public_path__ + "static/nicoleta-246c50843566cc96456244cf7c1fc922.png";